import { Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import StudyAbroadLayout from './StudyAbroadLayout';
import StudyAbroadHomePage from './StudyAbroadHomePage';
import GermanyHubPage from './GermanyHubPage';
import NewZealandHubPage from './NewZealandHubPage';
import NZGreenListPRGuidePage from './newzealand/NZGreenListPRGuidePage';
import NZCostOfStudyLivingPage from './newzealand/NZCostOfStudyLivingPage';
import NZStudentVisaGuidePage from './newzealand/NZStudentVisaGuidePage';
import UKHubPage from './UKHubPage';
import CanadaHubPage from './CanadaHubPage';
import AustraliaHubPage from './AustraliaHubPage';
import IrelandHubPage from './IrelandHubPage';
import BookCounsellingPage from './BookCounsellingPage';
import CompareDestinationsPage from './CompareDestinationsPage';
import CostCalculatorPage from './CostCalculatorPage';
import VisaEligibilityPage from './VisaEligibilityPage';
import DynamicCareerPage from './DynamicCareerPage';
import DubaiCompareTool from './DubaiCompareTool';
import DynamicStudyAbroadPage from './DynamicStudyAbroadPage';
import StudyAbroadThankYouPage from './StudyAbroadThankYouPage';
import FreeProfileEvaluationPage from './FreeProfileEvaluationPage';
import UKStudentVisaPage from './UKStudentVisaPage';
import UKBestUniversitiesPage from './UKBestUniversitiesPage';
import GermanyStudentVisaPage from './GermanyStudentVisaPage';
import GermanyAPSCertificatePage from './germany/GermanyAPSCertificatePage';
import GermanyBlockedAccountPage from './germany/GermanyBlockedAccountPage';
import GermanyPublicUniversitiesPage from './germany/GermanyPublicUniversitiesPage';
import GermanyCostOfStudyPage from './germany/GermanyCostOfStudyPage';
import GermanyScholarshipsPage from './germany/GermanyScholarshipsPage';
import GermanyAusbildungPage from './germany/GermanyAusbildungPage';
import GermanyPRAfterStudyPage from './germany/GermanyPRAfterStudyPage';
import GermanyJobsAfterMastersPage from './germany/GermanyJobsAfterMastersPage';
import GermanyStudentAccommodationPage from './germany/GermanyStudentAccommodationPage';
import GermanyIntakesPage from './germany/GermanyIntakesPage';
import AustraliaStudentVisaPage from './AustraliaStudentVisaPage';
import CanadaStudentVisaPage from './CanadaStudentVisaPage';
import IrelandStudentVisaPage from './IrelandStudentVisaPage';
import VisaComparisonPage from './VisaComparisonPage';
import ComparisonIndexPage from './comparison/ComparisonIndexPage';
import ComparisonPage from './comparison/ComparisonPage';
import AboutZafcoStudyAbroadPage from './AboutZafcoStudyAbroadPage';
import WhyChooseZafcoStudyAbroadPage from './WhyChooseZafcoStudyAbroadPage';
import GlobalPartnershipsPage from './GlobalPartnershipsPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import DubaiHubPage from './DubaiHubPage';
import DubaiCostOfLivingPage from './dubai/DubaiCostOfLivingPage';
import DubaiWorkRightsPage from './dubai/DubaiWorkRightsPage';
import DubaiGoldenVisaPage from './dubai/DubaiGoldenVisaPage';
import DubaiUniversitiesPage from './dubai/DubaiUniversitiesPage';
import DubaiTopCoursesPage from './dubai/DubaiTopCoursesPage';
import DubaiAboutZafcoPage from './dubai/DubaiAboutZafcoPage';
import DubaiWhyChooseZafcoPage from './dubai/DubaiWhyChooseZafcoPage';
import DubaiUniversityPartnershipsPage from './dubai/DubaiUniversityPartnershipsPage';
import DubaiEventsWebinarsPage from './dubai/DubaiEventsWebinarsPage';
import DubaiVisaSuccessStoriesPage from './dubai/DubaiVisaSuccessStoriesPage';
import LegacyPathRedirect from './components/LegacyPathRedirect';
const NavPrototypePage = lazy(() => import('./internal/NavPrototypePage'));

const StudyAbroadRouter = () => {
  return (
    <Routes>
      {/* INTERNAL design-validation prototype — noindex, no layout, not in sitemap, lazy-loaded (zero main-bundle impact) */}
      <Route path="internal/nav-prototype" element={<Suspense fallback={null}><NavPrototypePage /></Suspense>} />
      <Route element={<StudyAbroadLayout />}>
        {/* Priority Landing Pages */}
        <Route index element={<StudyAbroadHomePage />} />
        <Route path="germany" element={<GermanyHubPage />} />
        <Route path="newzealand" element={<NewZealandHubPage />} />
        <Route path="newzealand/green-list-pr-guide" element={<NZGreenListPRGuidePage />} />
        <Route path="newzealand/cost-of-study-living" element={<NZCostOfStudyLivingPage />} />
        <Route path="newzealand/student-visa-guide" element={<NZStudentVisaGuidePage />} />
        <Route path="uk" element={<UKHubPage />} />
        <Route path="canada" element={<CanadaHubPage />} />
        <Route path="australia" element={<AustraliaHubPage />} />
        <Route path="ireland" element={<IrelandHubPage />} />
        <Route path="book-counselling" element={<BookCounsellingPage />} />
        <Route path="compare" element={<CompareDestinationsPage />} />
        <Route path="cost-calculator" element={<CostCalculatorPage />} />
        <Route path="visa-eligibility" element={<VisaEligibilityPage />} />
        <Route path="visa-eligibility-checker" element={<VisaEligibilityPage />} />
        <Route path="free-profile-evaluation" element={<FreeProfileEvaluationPage />} />

        {/* UK Student Visa — Premium Content Engine */}
        <Route path="uk/student-visa" element={<UKStudentVisaPage />} />

        {/* UK Best Universities — Premium Content Engine */}
        <Route path="uk/best-universities" element={<UKBestUniversitiesPage />} />

        {/* Germany Student Visa — Premium Content Engine */}
        <Route path="germany/student-visa" element={<GermanyStudentVisaPage />} />

        {/* Germany Resource Cluster — top 5 spokes built Feb-2026 (rest follow) */}
        <Route path="germany/aps-certificate"     element={<GermanyAPSCertificatePage />} />
        <Route path="germany/blocked-account"     element={<GermanyBlockedAccountPage />} />
        <Route path="germany/public-universities" element={<GermanyPublicUniversitiesPage />} />
        <Route path="germany/cost-of-study"       element={<GermanyCostOfStudyPage />} />
        <Route path="germany/scholarships"        element={<GermanyScholarshipsPage />} />

        {/* Germany Resource Cluster — Wave 2 spokes (Feb-2026) */}
        <Route path="germany/ausbildung"            element={<GermanyAusbildungPage />} />
        <Route path="germany/pr-after-study"        element={<GermanyPRAfterStudyPage />} />
        <Route path="germany/jobs-after-masters"    element={<GermanyJobsAfterMastersPage />} />
        <Route path="germany/student-accommodation" element={<GermanyStudentAccommodationPage />} />
        <Route path="germany/intakes"               element={<GermanyIntakesPage />} />

        {/* Australia & Canada Student Visa — Premium Content Engines (Germany blueprint) */}
        <Route path="australia/student-visa" element={<AustraliaStudentVisaPage />} />
        <Route path="canada/student-visa" element={<CanadaStudentVisaPage />} />

        {/* Ireland D Study Visa — Premium Content Engine (Germany blueprint) */}
        <Route path="ireland/student-visa" element={<IrelandStudentVisaPage />} />

        {/* Visa Comparison Hub — DE / AU / CA / IE side-by-side (high-intent commercial keywords) */}
        <Route path="visa-comparison" element={<VisaComparisonPage />} />
        <Route path="comparison" element={<ComparisonIndexPage />} />
        <Route path="comparison/:slug" element={<ComparisonPage />} />

        {/* About — brand-level pages (linked from the About dropdown) */}
        <Route path="about-zafco" element={<AboutZafcoStudyAbroadPage />} />
        <Route path="why-choose-zafco" element={<WhyChooseZafcoStudyAbroadPage />} />
        <Route path="global-partnerships" element={<GlobalPartnershipsPage />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />

        {/* Dubai / UAE Hub — Premium 2026 Content Engine */}
        <Route path="dubai" element={<DubaiHubPage />} />
        <Route path="dubai/cost-of-living-tuition" element={<DubaiCostOfLivingPage />} />
        <Route path="dubai/student-work-rights" element={<DubaiWorkRightsPage />} />
        <Route path="dubai/golden-visa-post-study-pathways" element={<DubaiGoldenVisaPage />} />
        <Route path="dubai/universities" element={<DubaiUniversitiesPage />} />
        <Route path="dubai/top-courses-for-residency" element={<DubaiTopCoursesPage />} />
        <Route path="dubai/about-zafco" element={<DubaiAboutZafcoPage />} />
        <Route path="dubai/why-choose-zafco" element={<DubaiWhyChooseZafcoPage />} />
        <Route path="dubai/university-partnerships" element={<DubaiUniversityPartnershipsPage />} />
        <Route path="dubai/events-webinars" element={<DubaiEventsWebinarsPage />} />
        <Route path="dubai/visa-success-stories" element={<DubaiVisaSuccessStoriesPage />} />

        {/*
          301-equivalent Legacy URL Redirect (frozen, atomic mapping).
          Source : /study-abroad/visa/germany/student-visa-guide/
          Target : /study-abroad/germany/student-visa/
          Query params and hash are preserved by LegacyPathRedirect.
        */}
        <Route
          path="visa/germany/student-visa-guide"
          element={<LegacyPathRedirect to="/study-abroad/germany/student-visa" />}
        />
        <Route
          path="visa/germany/student-visa-guide/*"
          element={<LegacyPathRedirect to="/study-abroad/germany/student-visa" />}
        />

        {/* Careers & Jobs — Programmatic SEO Engine */}
        <Route path="careers" element={<DynamicCareerPage />} />
        <Route path="careers/:country/:slug" element={<DynamicCareerPage />} />
        <Route path="careers/:slug" element={<DynamicCareerPage />} />

        {/* Dubai University Side-by-Side Comparison Tool */}
        <Route path="dubai/compare" element={<DubaiCompareTool />} />
        <Route path="dubai/compare-universities" element={<DubaiCompareTool />} />

        {/* Dynamic catch-all template for all other study-abroad routes */}
        <Route path="thank-you" element={<StudyAbroadThankYouPage />} />
        <Route path="*" element={<DynamicStudyAbroadPage />} />
      </Route>
    </Routes>
  );
};

export default StudyAbroadRouter;
